<template>
  <div class="printTest">
    <p><button @click="generatePDFProcess"> Generate PDF </button></p>
    <p><button @click="generatePDFProtocol"> Generate PDF ver2 </button></p>
  </div>
</template>

<script>
import CommNew from "@processEditor/CommNew";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


import pdfMake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts'; // 빌드버전 사용가능 
import pdfFonts from '@components/pdf/pdfmake/vfs_fonts'; // 커스텀 버전 사용가능 

/* console.log({
  pdfFonts , 
  pdfMake , 
}) ;  */

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Pretendard: {
    normal: 'Pretendard-Light.ttf',
    bold: 'Pretendard-Regular.ttf',
    italics: 'Pretendard-Regular.ttf',
    bolditalics: 'Pretendard-Bold.ttf',
  } , 
  Roboto: {
    normal: 'Pretendard-Light.ttf',
    bold: 'Pretendard-Light.ttf',
    italics: 'Pretendard-Light.ttf',
    bolditalics: 'Pretendard-Light.ttf',
  } , 
  // Roboto: {
  //   normal: 'Roboto-Regular.ttf',
  //   bold: 'Roboto-Medium.ttf',
  //   italics: 'Roboto-Italic.ttf',
  //   bolditalics: 'Roboto-Medium.ttf'
  // } , 
};


export default {
  mixins:[ CommNew ] , 
  mounted () {} , 
  methods : {
    async generatePDFProtocol () {
      console.log( 'generatePDFProtocol in' ) ; 

      const docDefinition = {
        content: [
          { text: 'This is the title', style: 'title' },
          { text: '이것은 부제목입니다.', style: 'subtitle' },
          { text: 'This is some sample text in English.', style: 'body' },
          { text: '이것은 샘플 한글 텍스트입니다.', style: 'body' }
        ],
        styles: {
          title: {
            fontSize: 24,
            bold: true, 
          },
          subtitle: {
            fontSize: 18,
            bold: true,
            margin: [0, 20, 0, 10], 
            font: 'Pretendard'
          },
          body: {
            fontSize: 12,
            margin: [0, 10, 0, 10],
            bold: true,
            font: 'Pretendard'
          }
        }
      };

      pdfMake.createPdf(docDefinition).open();
      // pdfMake.createPdf(docDefinition).download();
    } , 

    // // A4 사이즈의 가로/세로 길이
    async generatePDFProcess () {
      const { crntDiagram } = this ; 
      const element = document.querySelector('#editor-process');
      const pageSize = { width: 210, height: 297 }; // A4 사이즈
      const [ bounds , { x , y , width : diagramWidth , height : diagramHeight }] = [ crntDiagram.computeBounds() , crntDiagram.computeBounds() ] ; 

      const scale = Math.min(element.clientWidth / diagramWidth, element.clientHeight / diagramHeight);
      crntDiagram.scale = scale;
      
      // Diagram을 페이지의 가운데로 이동
      const offsetX = (pageSize.width - diagramWidth * scale) / 2;
      const offsetY = (pageSize.height - diagramHeight * scale) / 2;
      const pos = new go.Point(-offsetX, -offsetY);
      crntDiagram.position = pos;

      html2canvas( crntDiagram.div , {
        scrollY: -window.scrollY, // 스크롤을 고정합니다.
        scale: 3,
        backgroundColor: '#fff',
        logging: true,
        dpi: 300,
        useCORS: true,
        width: element.clientWidth , 
        height: element.clientHeight , 
      }).then(canvas => {
        var pdf = new jsPDF("p", "mm", "a4");
        pdf.addImage(canvas.toDataURL("image/jpeg", 1.0), "JPEG", 0, 0, pageSize.width, pageSize.height);
        pdf.save("diagram.pdf");
      });
    } , 
  } , 
}
</script>

<style lang="scss" scoped>
.printTest {
  position: fixed; 
  left: 50%; top: 50%; 
  // padding: 50px; 
  z-index: 9999; 
  // background-color: #fff; 
  // box-shadow: 0 0 15px #000; 
  display: flex; 
  flex-direction: column; 
  gap: 20px; 

  button {
    background-color: #ccc; 
    padding: 10px;
  }
}
</style>        